/* The user’s account status */
export enum UserAuthenticationState {
  EMAIL_UNVERIFIED = 'EMAIL_UNVERIFIED',
  EMAIL_VERIFIED = 'EMAIL_VERIFIED',
  BLACK_LISTED = 'BLACK_LISTED',
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/model/user-authentication-state.ts